<template>
  <div :style="{ background: background }">
    <Vue100vh class="container main d-flex flex-column justify-content-between">
      <file-pond
        class="pt-3"
        ref="pond"
        labelIdle="Choose a file or drop it here..."
        acceptedFileTypes="image/jpeg, image/png"
        @addfilestart="handleAddFile"
        @removefile="handleRemovefile"
        :imagePreviewHeight="imagePreviewHeight"
      />
      <div class="pb-4">
        <div v-if="swatches" class="card color-boxes text-center">
          <div class="container">
            <div class="row">
              <div v-for="(swatch, i) in swatches" :key="i" class="color-box-wrap col-4 col-md-2">
                <color-box :swatch="swatch" />
              </div>
            </div>
          </div>
        </div>

        <div v-else>
          <SampleImages />
        </div>
      </div>
    </Vue100vh>
  </div>
</template>
 
<script>
// Import Vibrant
import * as Vibrant from "node-vibrant";

// Import Vue100vh
import Vue100vh from "vue-div-100vh";

// Import Vue FilePond
import vueFilePond from "vue-filepond";

// Import FilePond styles
import "filepond/dist/filepond.min.css";

// Import FilePond plugins
// Please note that you need to install these plugins separately

// Import image preview plugin styles
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";

// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import SampleImages from "@/components/SampleImages.vue";
import ColorBox from "@/components/ColorBox.vue";

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
);

export default {
  name: "Home",
  data() {
    return {
      background: "#fff",
      swatches: null,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight
    };
  },
  components: {
    Vue100vh,
    FilePond,
    SampleImages,
    ColorBox
  },
  watch: {
    swatches() {
      let self = this;
      try {
        self.background = self.rgbToHex(self.swatches["Vibrant"].rgb);
      } catch (error) {}
    }
  },
  computed: {
    imagePreviewHeight() {
      let height = this.windowHeight;
      let width = this.windowWidth;

      if (height >= 768 && width >= 768) {
        height = height * 0.7;
      } else {
        height = height * 0.5;
      }
      return height;
    }
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
      this.windowHeight = window.innerHeight;
    });
  },
  methods: {
    handleAddFile(files) {
      let self = this;
      let reader = new FileReader();

      reader.onload = function() {
        let path = reader.result;

        Vibrant.from(path).getPalette(
          (err, palette) => (self.swatches = palette)
        );

        try {
          self.background = self.rgbToHex(self.swatches["Vibrant"].rgb);
        } catch (error) {}
      };
      reader.readAsDataURL(files.file);
    },
    handleRemovefile() {
      this.swatches = null;
      this.background = "#fff";
    },
    rgbToHex(rgb) {
      let hex = Vibrant.Util.rgbToHex(rgb[0], rgb[1], rgb[2]);
      return hex;
    }
  }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Share+Tech+Mono&display=swap");

.main {
  // height: 100vh;
  overflow: hidden;
}

.card {
  border: none;
  border-radius: 0.5em;
  min-height: 90px;
}
.color-box-wrap {
  padding: 1vh 0;
}

.filepond--file-info {
  display: none;
}
</style>
